/**
 * @generated SignedSource<<709f1d42f289f59960e5ef6f5c887467>>
 * @relayHash 0ec9ccb99f55638b4d90964ba0233fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a85e2c0b063405d75f696fe88da52aef8cfe3874acb5e94a320058cbe2f8069

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GrowthRecContext = {
  anonymousId?: string | null | undefined;
  containers?: AGG$JSON | null | undefined;
  custom?: AGG$JSON | null | undefined;
  locale?: string | null | undefined;
  orgId?: string | null | undefined;
  product?: string | null | undefined;
  sessionId?: string | null | undefined;
  subproduct?: string | null | undefined;
  tenantId?: string | null | undefined;
  useCase?: string | null | undefined;
  userId?: string | null | undefined;
  workspaceId?: string | null | undefined;
};
export type AdvancedAdminControlsRecommendationsQuery$variables = {
  context?: GrowthRecContext | null | undefined;
  first?: number | null | undefined;
};
export type AdvancedAdminControlsRecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly data?: ReadonlyArray<{
        readonly entityId: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AdvancedAdminControlsRecommendationsQuery = {
  response: AdvancedAdminControlsRecommendationsQuery$data;
  variables: AdvancedAdminControlsRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "context"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AdvancedAdminControlsRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdvancedAdminControlsRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ],
                "type": "GrowthRecRecommendations"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6a85e2c0b063405d75f696fe88da52aef8cfe3874acb5e94a320058cbe2f8069",
    "metadata": {},
    "name": "AdvancedAdminControlsRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a07263cc5d40b6fd5933c2b74ed403c6";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
